import * as React from "react";
import Grid from "@mui/material/Grid";
import styles from "../../assets/css/LeftNav.module.css";
import { ReactComponent as ReportSVG } from "../../assets/svg/ClientReport.svg";
import { ReactComponent as DashboardSVG } from "../../assets/svg/Dashboard.svg";
import { ReactComponent as UpdatesSVG } from "../../assets/svg/Updates.svg";
import { ReactComponent as ClientInvestmentMasterSVG } from "../../assets/svg/ClientInvestmentMaster.svg";
import { ReactComponent as FormsDownloadSVG } from "../../assets/svg/FormsDownload.svg";
// import { ReactComponent as KfinLogo } from "../../assets/svg/axisleftnav.svg";
import { ReactComponent as KfinLogo } from "../../assets/svg/KfintechNavBarLogo.svg";
import { ReactComponent as BokerageSVG } from "../../assets/svg/Brokerage Tab logo.svg";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { useEffect } from "react";
import { AMC_DETAILS } from "../../variable";

function LeftNavDistributor(props) {
  return (
    <div style={{ paddingTop: "65px", zIndex: "2" }}>
      <Grid
        className={styles.leftNavBar}
        container
        maxWidth={"18rem"}
        minWidth={"18rem"}
        marginTop={"-63px"}
        spacing={2}
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        position="fixed"
      >
        {" "}
        <Grid
          item
          className={styles.leftTile}
          style={{
            paddingTop: " 70px",
            paddingLeft: "35px",
            paddingBottom: "50px",
            zIndex: "4",
          }}
        >
          <KfinLogo />
        </Grid>
        <Grid
          item
          className={
            props.page === "DIS" ? styles.leftTileGolden : styles.leftTile
          }
          // style={{ borderBottom: "solid 2px #AD9042" }}
        >
          <NavLink
            to="/distributor/dashboard"
            style={{ textDecoration: "none" }}
            className={styles.leftTile}
          >
            <DashboardSVG className={styles.tileSvg} />
            Dashboard
          </NavLink>
        </Grid>
        <Grid
          item
          className={
            props.page === "RecentTransactionDistributor"
              ? styles.leftTileGolden
              : styles.leftTile
          }
          // style={{ borderBottom: "solid 2px #AD9042" }}
        >
          <NavLink
            to="/distributor/investmentMaster"
            style={{ textDecoration: "none" }}
            className={styles.leftTile}
          >
            <ClientInvestmentMasterSVG className={styles.tileSvg} />
            Investment Master
          </NavLink>
        </Grid>
        <Grid
          item
          className={
            props.page === "CLID" ? styles.leftTileGolden : styles.leftTile
          }
          // style={{ borderBottom: "solid 2px #AD9042" }}
        >
          <NavLink
            to="/distributor/investorReports"
            style={{ textDecoration: "none" }}
            className={styles.leftTile}
          >
            <ReportSVG className={styles.tileSvg} />
            Investor Reports
          </NavLink>
        </Grid>
        <Grid
          item
          className={
            props.page === "UpdatesAndAnnouncementsDistributor"
              ? styles.leftTileGolden
              : styles.leftTile
          }
          // style={{ borderBottom: "solid 2px #AD9042" }}
        >
          <Grid
            item
            xs={12}
            // style={{ display: "flex", justifyContent: "space-around" }}
          >
            <NavLink
              to="/distributor/updates"
              style={{ textDecoration: "none" }}
              className={styles.leftTile}
            >
              <UpdatesSVG className={styles.tileSvg} />
              Updates &nbsp;&nbsp;&nbsp;&nbsp;
              {props.unread ? (
                <span className={styles.dot}>{props.unread}</span>
              ) : (
                <></>
              )}
            </NavLink>
          </Grid>
        </Grid>
        <Grid
          item
          className={
            props.page === "FormsAndDownloadDistributor"
              ? styles.leftTileGolden
              : styles.leftTile
          }
          // style={{ borderBottom: "solid 2px #AD9042" }}
        >
          <NavLink
            to="/distributor/standardForms"
            style={{ textDecoration: "none" }}
            className={styles.leftTile}
          >
            <FormsDownloadSVG className={styles.tileSvg} />
            Standard Forms
          </NavLink>
        </Grid>
        {AMC_DETAILS.ENABLE_BROKERAGE && (
          <Grid
            item
            className={
              props.page === "Brokerage"
                ? styles.leftTileGolden
                : styles.leftTile
            }
            // style={{ borderBottom: "solid 2px #AD9042" }}
          >
            <NavLink
              to="/distributor/brokerage"
              style={{ textDecoration: "none" }}
              className={styles.leftTile}
            >
              <BokerageSVG className={styles.tileSvg} />
              Brokerage
            </NavLink>
          </Grid>
        )}
        <Grid item className={styles.lastTile}></Grid>
      </Grid>
    </div>
  );
}

const mapStatetoProps = (state) => {
  return {
    page: state.mainReducer.page,
    userDetails: state.mainReducer.userDetails,
    unread: state.mainReducer.unread,
  };
};
export default connect(mapStatetoProps)(LeftNavDistributor);
